import { render, staticRenderFns } from "./PersonProfileSdt.vue?vue&type=template&id=07d163b6&scoped=true"
import script from "./PersonProfileSdt.vue?vue&type=script&lang=js"
export * from "./PersonProfileSdt.vue?vue&type=script&lang=js"
import style0 from "./PersonProfileSdt.vue?vue&type=style&index=0&id=07d163b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d163b6",
  null
  
)

export default component.exports